import styled, { css } from 'styled-components'

import { theme } from '../../../theme'

import type { StyledFormItemProps } from '../FormItem/types'

export const FormItem = styled.div<StyledFormItemProps>`
  ${({ $isFullWidth }) =>
    $isFullWidth &&
    css`
      width: 100%;
    `}
  display: block;
  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`

export const ErrorMessage = styled.div`
  font-family: ${theme.fonts.mainFont};
  font-weight: normal;
  font-size: 14px;
  color: ${theme.colors.danger};
`

export const HintMessage = styled.div`
  font-family: ${theme.fonts.mainFont};
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
  color: ${theme.colors.purpleOde};
  margin-top: 5px;
`
